import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    iFrameId: PropTypes.string,
    className: PropTypes.string,
    title: PropTypes.string,
    role: PropTypes.string,
};

const defaultProps = {
    iFrameId: 'mzl-iframe',
    className: 'mzlIFrame',
    title: 'iframe',
    role: '',
};

const IFrame = React.forwardRef((props, ref) => {
    const extraAttrs = {};
    if (!!props.role) {
        extraAttrs['role'] = props.role;
    }
    
    return (
        <iframe
            id={props.iFrameId}
            className={props.className}
            ref={ref}
            src={props.url}
            title={props.title}
            frameBorder="0"
            height="100%"
            width="100%"
            allowFullScreen="1"
            allow="microphone"
            tabIndex={props.tabIndex}
            {...extraAttrs}
        />
    );
});

IFrame.propTypes = propTypes;
IFrame.defaultProps = defaultProps;

export default IFrame;